var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-outTabs"},[_c('div',{staticClass:"h100vh-140",attrs:{"id":"nsiTable"}},[_c('NSIMenu',{on:{"methodEnum":_vm.methodEnum}}),_c('NSITable',{ref:"nsiTable"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }